import _ from "lodash";

export class Scenario {
    constructor(props) {
        this.props = props;
    }

    getDisplayName() {
        if (!this.props.name) return "";
        return `${this.props.name || ""} ${_.get(
            this.props,
            "options.projection.typeProjection",
            ""
        )}`;
    }

    getScenarioParams() {
        const scenarios = {
            PROGRESSAO_LINEAR: {
                name: "Projeção Linear",
                options: { projection: "PROGRESSAO_LINEAR" },
                _id: "ORIGINAL"
            },
            ORIGINAL: {
                name: "Original",
                options: { filterProjectionPoints: true },
                _id: "ORIGINAL"
            }
        };
        return scenarios[this.props._id] || { ...this.props, options: {} };
    }

    getScenarioIdByType() {
        if (["budget", "projection"].includes(this.props.type))
            return "ORIGINAL";
        return this.props._id;
    }

    getBudgetActive() {
        if (this.props.type === "budget") return this.props._id;
        return false;
    }

    getProjectionActive() {
        if (this.props.type === "projection") return this.props._id;
        return false;
    }
}
